<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">期刊动态</div>
                  <div class="title_more2"><a href="/">首页</a>>期刊动态</div>
                  <div class="clearfix"></div>
                </div>
                <listContent :params="{ ColumnId: 2 }"></listContent>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl></DocumentsNewsBlockControl>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentsNewsBlockControl from '../components/DocumentsNewsBlockControl/DocumentsNewsBlockControl'
import listContent from '../components/listContent'
export default {
  inject: ['reload'],
  data() {
    return {}
  },
  components: {
    DocumentsNewsBlockControl,
    listContent,
  },
  created() {
    document.title = '期刊动态'
    this.reload()
  },
  mounted() {},
  methods: {},
}
</script>

<style scoped></style>
